import { Component, Input, Output, OnChanges, SimpleChanges, SimpleChange, EventEmitter } from '@angular/core';
import { Observable, Subject } from 'rxjs/Rx';
import { NetFacadeService } from '../../../services/netfacade.service';
import { AgentDto } from 'UvExplorerServer.Dtos.TS/Agents';
import { NetViewDto } from 'UvExplorerServer.Dtos.TS/NetViews';
import { MessageService } from 'base';


@Component({
    selector: 'new-network-dialog',
	templateUrl: './newnetwork.component.html',
    styleUrls: ['./newnetwork.component.scss']
})
export class NewNetworkDialogComponent {

    @Input() display: boolean = false;
	@Output() onSuccess = new EventEmitter();
	@Output() onClose = new EventEmitter();

    newItemName: string = "";
    newItemDesc: string = "";

	constructor(private netFacadeService: NetFacadeService,
				private messageService: MessageService) {
    }

	public ngOnChanges(changes: SimpleChanges): void {
		let change: SimpleChange = null;

		change = changes["display"];
		if (change) {
			if (this.display) {
				this.newItemName = "";
				this.newItemDesc = "";
			}
		}
	}

	public onDialogHide(): void {
		this.onClose.emit(true);
	}

    public addNewNetwork(): void {
		this.netFacadeService.createNetwork(this.newItemName, this.newItemDesc).subscribe(
			(newNetwork: NetViewDto) => {
				this.onSuccess.emit(true);
			},
			(error: any) => {
				this.messageService.displayErrorMessage("Network creation failed");
			});
    }

    public displayDialog() {
        this.display = true;
    }

    public hideDialog() {
        this.display = false;
    }


}
